import { ThemedAccessDeniedNavigate } from '../components/theme/ThemedAccessDeniedState'
import { useUserAuthorization } from '../context/UserAuthorizationContext'
import { ContentSkeleton } from '../layouts/ContentSkeleton'
import { getFirstAccessiblePath } from '../lib/userNavAccess'
import { useTheme } from '../theme/ThemeContext'

export function ForbiddenPage() {
  const { theme } = useTheme()
  const { permissions } = useUserAuthorization()
  const fallback = getFirstAccessiblePath(permissions)

  return (
    <ContentSkeleton
      title="无权访问"
      breadcrumbs={[
        { label: '首页', to: fallback },
        { label: '无权访问' },
      ]}
      adminLayout
      framed={false}
      scrollableBody={false}
    >
      <ThemedAccessDeniedNavigate theme={theme} to={fallback} />
    </ContentSkeleton>
  )
}
